import {isLegacyItem}      from "@Common/logic/item/is-legacy-item";
import {cc}                from "@Common/react/callback-chain";
import {cs}                from "@Common/react/chain-services";
import {scopedState}       from "@Common/react/scoped-state";
import {scn}               from "@Common/react/state-change-nested-value";
import {UseState}          from "@Common/react/use-state";
import {changeNestedValue} from "@Common/utils/arr-path";
import {chain}             from "@Common/utils/fs";

/**
 * This is for the embedded PDF download section for shipping, pickup..., not the "download" method. For "download" method, check "download-delivery-logic" file.
 */
export const PdfDownloadLogic = ({item, templateOptions, method, next: rootNext}) => cs(
    ["state", (_, next) => UseState({
        getInitValue: () => cc([
            (_, next) => chain(
                next(),
                (_) => ({
                    saved: _,
                    current: _,
                }),
            ),
            (_, next) => !item || isLegacyItem(item) ? null : next(), // null for default
            () => !!(item.selections?.options?.find((o) => o.dev_key === "pdf_download")),
        ]),
        next,
    })],

    ["step1", ({}, next) => rootNext({
        cleanItem: (item) => changeNestedValue(item, ["selections", "options"], (_) => _?.filter((o) =>
            o.dev_key !== "pdf_download"
        )),
        next,
    })],

    ["pdfDownloadPrice", (_, next) => next(getPdfDownloadPrice(templateOptions, method))],

    ({step1, state, pdfDownloadPrice}) => step1.next(pdfDownloadPrice === undefined ? null : (() => {
        const currentValue = state.value.current != null ? (
            state.value.current
        ) : (
            pdfDownloadPrice === 0
        );
        return {
            itemEditor: {
                $name: "pdf download",
                prepareSave: (item) => ({
                    newValue: changeNestedValue(item, ["selections", "options"], (_) => !currentValue ? _ : [
                        ..._??[],
                        {
                            "name": "PDF Download",
                            "dev_key": "pdf_download",
                            value: true,
                        },
                    ]),
                    onSaved: () => scn(state, ["saved"], () => currentValue),
                }),

                changed: state.value.saved !== currentValue,

                valid: true,
            },


            pdfDownloadPrice,
            state: {
                ...scopedState(state, ["current"]),
                value: currentValue,
            },
        };
    })()),
);

const getPdfDownloadPrice = (templateOptions, method) => {
    for (let i = 0; i < templateOptions.options.length; i++) {
        const option = templateOptions.options[i];
        if (option.dev_key === "pdf_download" && ~option.distributionFilter.indexOf(method)) {
            return +(option.flatPrice||0);
        }
    }
    return null;
};